import React, { useState, useEffect } from 'react';
import Image from 'next/image';
import { useWindowSize } from 'react-use';
import Link from 'next/link';
import { STATIC_FILE_URL } from '@/shared/constants';
import { IFeaturedImage } from '@/shared/types/existing-brands';
import { CASE_STUDY_LINK } from '@/shared/constants/existing-brands';
import './index.less';

type BreakpointsType = '300' | '640' | '768' | '1024' | '1280';

const images: string[] = [
  `${STATIC_FILE_URL}/434b5f2f59f95edb3e449f8a809485a0.png`,
  `${STATIC_FILE_URL}/c933bffa65012289cd2ff22eadcb8f56.png`,
  `${STATIC_FILE_URL}/84ae215541dca017c6bf7476b63a39ac.png`,
];

const sayings: string[] = [
  `"Pietra is a great resource for all your product needs. Working with their team has made development a seamless process!"`,
  `"Pietra has saved us time & money by partnering with the right suppliers. Their fulfillment center has also been incredible to work with in regards to customer service, low incidents, and shipping speed."`,
  `"Shifting from my current SMS marketing solution to Pietra was so seamless. The product also offered better reporting and the first campaign resulted in a higher CTR than my previous solution at 38% the cost!"`,
];

const caseStudyLogos: Record<BreakpointsType, IFeaturedImage> = {
  '300': { width: 344, height: 236, title: 'Arrae', link: `${STATIC_FILE_URL}/4620359d839c6012bcdc6f4a3fe029bf.png` },
  '640': { width: 584, height: 364, title: 'Arrae', link: `${STATIC_FILE_URL}/981f9cc53f55bd77558a4a57af35fc33.png` },
  '768': { width: 696, height: 364, title: 'Arrae', link: `${STATIC_FILE_URL}/e4a5e1c3bb535453d75dbba454e8b227.png` },
  '1024': { width: 936, height: 364, title: 'Arrae', link: `${STATIC_FILE_URL}/f602fb80ddb75409aa47685cf68b519c.png` },
  '1280': { width: 1192, height: 364, title: 'Arrae', link: `${STATIC_FILE_URL}/0d9141abc56a24d4b2901f281dcdc7b1.png` },
};

const SocialProof = () => {
  const [sayingIdx, setSayingIdx] = useState<number>(0);
  const [breakpoint, setBreakpoint] = useState<BreakpointsType>();
  const { width } = useWindowSize();

  const caseStudyLogo = caseStudyLogos[breakpoint];

  useEffect(() => {
    if (width >= 1280) {
      setBreakpoint('1280');
    } else if (width >= 1024) {
      setBreakpoint('1024');
    } else if (width >= 768) {
      setBreakpoint('768');
    } else if (width >= 640) {
      setBreakpoint('640');
    } else {
      setBreakpoint('300');
    }
  }, [width]);

  return (
    <div className="social-proof">
      <div className="social-proof-container">
        <div className="header">
          <h1>Brands who are saving more with Pietra</h1>
          <p>Visionary brand owners use Pietra to grow businesses.</p>
        </div>
        <div className="card-container">
          {images.map((url, index) => (
            <div key={url} className="image-container" onMouseOver={() => setSayingIdx(index)}>
              <Image src={url} alt="image" width={370} height={364} />
            </div>
          ))}
        </div>
        <p className="sayings">{sayings[sayingIdx]}</p>
        <div className="case-study">
          <h1>Case Study</h1>
          <Link href={CASE_STUDY_LINK}>
            <div className="case-study-logo">
              <Image
                src={caseStudyLogo?.link}
                alt={caseStudyLogo?.title}
                width={caseStudyLogo?.width}
                height={caseStudyLogo?.height}
              />
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SocialProof;
